import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import type { FieldType } from '../field-types';

const checkboxFieldType: FieldType<DatabaseFieldType.CHECKBOX> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY,
  ],
  isCsvImportSupported: true,
  renderExportView: ({ value }) => `${value}`,
  parseFromHtml: (el) => {
    const textContent = el.find('span').text();
    return textContent === 'true';
  },
  getInitialValue: () => false,
  isEmptyValue: () => false, // a checkbox is never empty. there is no way to differentiate between an untouched checkbox or one unchecked.
  isEqualValue: ({ value: value1 }, { value: value2 }) => value1 === value2,
  getStringRepresentation: ({ value }) => `${value}`,
  convertFrom: {
    [DatabaseFieldType.TEXT]: (context) => {
      return context.value === 'true';
    },
  },
};
export default checkboxFieldType;
